export default "__VITE_ASSET__DjVnG8P8__"